<div class="carregando" [class.carregando--sobreposicao]="modo === 'sobreposicao'" role="status" aria-live="polite">
  <span class="carregando__spinner" aria-hidden="true"></span>
  <span class="carregando__texto">{{ mensagem }}</span>
</div>
